import Repository from "./Repository";

const users = "/users";

export default {
  createUser: (user) => Repository.post(`${users}/`, user),
  getUser: (username, options = {}) => {
    const params = {};

    // default to true, add explicit param only if false
    if (options.needSession === false) {
      params.need_session = "false";
    }
    return Repository.get(`${users}/${username}/`, { params });
  },
  editUser: (username, payload) =>
    Repository.patch(`${users}/${username}/`, payload),
  deleteUser: (username) => Repository.delete(`${users}/${username}/`),
  sendEmail: (username, payload) =>
    Repository.post(`${users}/${username}/send_email/`, payload),
  changePassword: (username, payload) =>
    Repository.post(`${users}/${username}/change_password/`, payload),
  getLocalization: () => Repository.get(`${users}/get_localization/`),
  getUserPersonalData: (username) =>
    Repository.get(`${users}/${username}/download_data/`),
  updateLocale: (username, payload) =>
    Repository.patch(`${users}/${username}/update_locale/`, payload),
  updateLastLogin: (username) =>
    Repository.patch(`${users}/${username}/update_last_login/`),
};
